module.exports = __webpack_public_path__ + "static/media/world_wide_web_flatline.c75467c4.svg";